import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs/operators';

import { TemplateService } from '../../../../../../core/lists/_services/template.service';
import { TaskTemplate } from '../../../../calendar/models';

@Component({
  selector: 'kt-template-duplicate',
  templateUrl: './template-duplicate.component.html',
  styleUrls: ['./template-duplicate.component.scss'],
})
export class TemplateDuplicateComponent {
  nameCtrl = new FormControl('', Validators.required);

  constructor(
    @Inject(MAT_DIALOG_DATA) public template: TaskTemplate,
    private dialogRef: MatDialogRef<TemplateDuplicateComponent>,
    private templateService: TemplateService,
  ) {}

  close(event: Event, data?: any): void {
    event?.stopPropagation();

    this.dialogRef.close(data);
  }

  save(event: Event): void {
    event.stopPropagation();

    this.nameCtrl.markAsTouched();
    this.nameCtrl.updateValueAndValidity();

    if (this.nameCtrl.invalid) return;

    this.templateService
      .duplicateTemplate(this.template.id, this.nameCtrl.value)
      .pipe(take(1))
      .subscribe((res) => {
        if (!res) return;

        this.close(null, res);
      });
  }
}
